import { render, staticRenderFns } from "./CadastrarPainelUnidade.vue?vue&type=template&id=7644af86&scoped=true"
import script from "./CadastrarPainelUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarPainelUnidade.vue?vue&type=script&lang=js"
import style0 from "./CadastrarPainelUnidade.vue?vue&type=style&index=0&id=7644af86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644af86",
  null
  
)

export default component.exports